import compose from 'lodash/fp/compose'
import filter from 'lodash/fp/filter'
import flatMap from 'lodash/fp/flatMap'

//noinspection JSUnusedGlobalSymbols
export default {

    all: state => Object.values(state.entities),

    allByOfferId: (state, getters) => offerId => {
        //noinspection JSUnresolvedVariable
        return getters['all'].filter(price => price.offer === offerId)
    },

    allByVariantId: (state, getters, rootState, rootGetters) => variantId => {
        return compose(

            // Preise zu Angeboten holen
            flatMap(offerModel => getters['allByOfferId'](offerModel.id)),

            // Angebote holen
            rootGetters['offers/allByVariantId']

        )(variantId)
    },

    allByVariantIdAndIsPublished: (state, getters) => variantId => {
        return compose(

            // Preise filtern, die "published" sind
            filter(priceModel => priceModel.isPublished === true),

            // Preise zu Angeboten holen
            getters['allByVariantId'],

        )(variantId)
    },

    byId: state => id => {
        return state.entities[id]
    },

}


